/** Marca de la app: ícono de Damateur + nombre «GazeLab». */
export function BrandMark({ tone = "dark", size = 32 }: { tone?: "dark" | "light"; size?: number }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <img src="/brand/damateur-icon-192.png" alt="" width={size} height={size} className="shrink-0 rounded-full" />
      <span className="flex flex-col leading-none">
        <span className={`font-display text-lg font-bold tracking-tight ${tone === "dark" ? "text-white" : "text-ink"}`}>
          GazeLab<span className="text-aqua">.</span>
        </span>
        <span className={`font-util text-[0.6rem] uppercase tracking-[0.28em] ${tone === "dark" ? "text-aqua/80" : "text-sky-700"}`}>
          Damateur
        </span>
      </span>
    </span>
  );
}
